export const methodology = {
  text: "Methodology",
  title1: "Our Approach",
  paragraph1:
    "In early 2016, the GDHM team, together with representatives from 20+ countries and 50+ international agencies and organizations, designed version 1.0 of the Global Digital Health Index (GDHI).\n" +
    "        In 2022, the resource underwent a year-long indicator and platform review and redesign process to align the indicators with the WHO Global Digital Health Strategy as a complement to the WHO Digital Health Atlas and includes a greater focus on AI,\n" +
    "        equity, gender, and Universal Health Coverage. In addition, the name was changed to the Global Digital Health Monitor (GDHM) to articulate the tool’s value in providing a platform to monitor digital health progress at a country, regional and global level.\n" +
    "        The updated GDHM includes year on year performance monitoring country visualizations, regional visualizations, and country to country comparisons.",
  bulletin: {
    title: "To develop the indicators, the GDHM team:",
    line1:
      "Conducted a landscape review of global data available through multilateral organizations.",
    line2:
      "Mapped available data by reviewing existing frameworks and tools developed by experts to help practitioners\n" +
      "     and countries assess the strength and maturity of the enabling environment relevant to digital health.",
    line3:
      "Convened digital health experts to develop use cases for GDHM and refine and define an initial set\n" +
      "     of recommended indicators into a user-friendly and manageable list.",
  },
  paragraph2: "List of GDHM Indicators - ",
  seeHere: "See here",

  title2: "Data Collection and Verification",
  paragraph3Start:
    "The GDHM team works with country partners and Ministry of Health representatives who are\n" +
    "        leading digital health efforts in their respective countries to collect data for each country.\n" +
    "        These country partners submit their country’s data through an annual GDHM survey,\n" +
    "        and select the appropriate phase for each indicator as well as rationale and evidence to support these phases.\n" +
    "        The GDHM team verifies the collected data before publishing it. Broader Health Data from the",
  paragraph3Link: "World Bank Development Indicators 2019",
  paragraph3End: "has been included to contextualize digital health maturity.",

  title3: "Calculating Averages and Benchmarking",
  paragraph4:
    "The GDHM uses the main indicators in each category to calculate the overall country average.\n" +
    "        While sub-indicators are included to add greater specificity to specific GDHM indicators,\n" +
    "        they are not used in calculating the Component Phase or the Country or Global Averages.\n" +
    "        The GDHM enables countries to benchmark themselves against the Global Average or a specific overall phase.",

  title4: "Pre-populated data from publicly available sources",
  paragraph5:
    "For countries that have not completed a survey in the Global Digital Health Monitor, data was extracted from publicly available information to pre-populate the indicators below to give a general sense of broader digital ecosystem maturity in alignment with relevant indicators. While this data serves as a proxy for these digital health indicators for countries, data completed by government officials provide a more accurate and robust picture of the digital health progress in each country. We encourage countries that have not submitted full data to request a country link to do so at their earliest convenience.\n",
  indicators: {
    bulletin: {
      title:
        "Indicators that used proxy data from publicly available sources to pre-populate countries that have not completed a survey: ",
      line1:
        "Indicator 2a: Health is prioritized in national digital transformation and data governance policies",
      line2:
        "Indicator 4: Diversity, Equity, and human rights analysis, planning and monitoring included in national digital health strategies and plans",
      line3:
        "Indicator 6a: private sector participation and investments in digital health",
      line4: "Indicator 7: legal framework for data protection (security)",
      line5:
        "Indicator 8: Laws or Regulations for privacy, consent, confidentiality, and access to health information (Privacy)",
      line6:
        "Indicator 9: Protocol for regulating or certifying devices and/or health services- including provisions for AI and algorithms (at higher stages of maturity)",
      line7: "Indicator 17: Network readiness",
      line8:
        "Indicator 18: Planning and support for ongoing digital health infrastructure maintenance",
    },
    paragraph: {
      start: "Data sources included the ",
      govTech: "GovTech Maturity Indicator",
      GTMI: "(GTMI)",
      NRI: "Network Readiness Index",
      GCI: "Global Cybersecurity Index",
      GSMA: "GSMA Mobile Connectivity Index",
      the: "the",
      andThe: "and the",
    },
  },
};
